/**
 * Decode a JWT payload WITHOUT signature verification. For UI hydration only —
 * the server signs and re-verifies on every API call; do NOT use this output
 * for authorization decisions client-side.
 *
 * Contract:
 * - Returns null on any parse failure (malformed JWT, base64 decode error,
 *   JSON parse error, missing segments). NEVER throws.
 * - The caller (hydrateFromAccessToken) MUST handle null by transitioning
 *   useAuthStore to status="anonymous" without triggering forceLogoutAndRedirect.
 */
export function decodeJwtPayload(token: string): Record<string, unknown> | null {
  try {
    const segments = token.split(".");
    if (segments.length !== 3) return null;
    const seg = segments[1];
    if (!seg) return null;
    const padded = seg
      .replace(/-/g, "+")
      .replace(/_/g, "/")
      .padEnd(seg.length + ((4 - (seg.length % 4)) % 4), "=");
    const json = atob(padded);
    const payload: unknown = JSON.parse(json);
    if (!payload || typeof payload !== "object") return null;
    return payload as Record<string, unknown>;
  } catch {
    return null;
  }
}
